export default __webpack_public_path__ + "static/media/manufacturer1.8c8dd0fd.png";